import axios from 'axios'

export default {
  async list (filter) {
    const path = `${process.env.VUE_APP_API_URL}/api/v2/card-transactions`
    const response = await axios.get(path, {
      params: {
        index: filter.index,
        length: filter.length,
        taxDocument: filter.taxDocument,
        nsu: filter.nsu,
        cardFinal: filter.cardFinal,
        cardBrand: filter.cardBrand,
        amount: filter.amount,
        acquirerNsu: filter.acquirerNsu,
        status: filter.status,
        paidAt: filter.paidAt,
        type: filter.type
      }
    })

    return response.data
  },
  async cancel (model) {
    const path = `${process.env.VUE_APP_PAYMENTS_API_URL}/transactions/cancel`
    const response = await axios.post(path, { cards: model }).catch(error => { return error.response })

    return response.data
  }
}
